var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import * as _ from "lodash";
var BaseClient = /** @class */ (function () {
    function BaseClient(_baseUrl) {
        this._baseUrl = _baseUrl;
        this._token = "";
        this._debug = false;
        this._mutexes = {};
        this._errorMap = {};
        var a = window.webkit;
        if (a)
            this._webkit = a.messageHandlers.axios;
    }
    /*
    Helper method to get data from the back-end using the client class and
    call the dispatcher on a CONNECTED react component.
  
    parameters:
      component     A react component with properties including "IConnectedComponent" props
                    (this includes dispatcher and state)
      promise       The result of a client call i.e. getUsers or something like that
      action        Action to dispatch after successfully get data from the back-end.
    */
    BaseClient.prototype.setErrorHandler = function (code, func) {
        this._errorMap[code] = func;
    };
    Object.defineProperty(BaseClient.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseClient.prototype, "debug", {
        set: function (val) {
            this._debug = val;
        },
        enumerable: true,
        configurable: true
    });
    BaseClient.prototype.lockMutex = function (name) {
        if (!name)
            return true;
        if (this._mutexes[name])
            return false;
        this._mutexes[name] = true;
        return true;
    };
    BaseClient.prototype.unlockMutex = function (name) {
        if (!name)
            return true;
        if (!this._mutexes[name])
            return false;
        this._mutexes[name] = false;
        return true;
    };
    BaseClient.prototype.checkMutex = function (name) {
        return this._mutexes !== undefined ? this._mutexes : false;
    };
    Object.defineProperty(BaseClient.prototype, "token", {
        get: function () {
            return this._token;
        },
        set: function (value) {
            this._token = value;
        },
        enumerable: true,
        configurable: true
    });
    BaseClient.prototype.isAuthenicated = function () {
        return this.token !== "";
    };
    BaseClient.prototype.canExecute = function (links, ref) {
        return _.find(links, function (link) { return link.ref === ref; });
    };
    BaseClient.prototype.login = function (uri, data) {
        var _this = this;
        var toRet = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var config, response, error_1, t;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            baseURL: this.baseUrl,
                            url: uri,
                            method: "POST",
                            data: data,
                            withCredentials: true
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios(config)];
                    case 2:
                        response = _a.sent();
                        if (response.status !== 200)
                            reject({ errorReason: response.status + " returned expected " + 200, statusCode: response.status });
                        resolve(response.data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        reject({ errorReason: error_1 });
                        return [3 /*break*/, 4];
                    case 4:
                        t = undefined;
                        resolve(t);
                        return [2 /*return*/];
                }
            });
        }); });
        return toRet;
    };
    BaseClient.prototype.call = function (params) {
        var _this = this;
        if (this._debug)
            console.log("params = ", params);
        if (this.lockMutex(params.mutex)) {
            var uri = params.uri;
            if (uri.startsWith("/"))
                uri = uri.substr(1);
            if (uri.endsWith("/"))
                uri = uri.substr(0, uri.length - 1);
            this.callMethod({
                uri: uri,
                method: params.method,
                data: params.data,
                pathElements: params.pathElements,
                responseStatus: params.responseStatus ? params.responseStatus : [200, 201, 304],
                type: params.type ? params.type : "json",
                onProgress: params.onProgress
            })
                .then(function (val) {
                _this.unlockMutex(params.mutex);
                if (params.onSuccess)
                    params.onSuccess(val);
            }, function (reason) {
                if (reason.statusCode) {
                    if (params.errorResponseCodeMap && params.errorResponseCodeMap[reason.statusCode])
                        params.errorResponseCodeMap[reason.statusCode]();
                    if (_this._errorMap[reason.statusCode])
                        _this._errorMap[reason.statusCode]();
                }
                _this.unlockMutex(params.mutex);
                if (params.onError)
                    params.onError(reason);
            });
        }
    };
    BaseClient.prototype.callMethod = function (data) {
        var _this = this;
        if (this._debug)
            console.log("data = ", data);
        var toRet = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var path, headers, config, response, rcodes, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "";
                        if (data.pathElements)
                            _.forEach(data.pathElements, function (v) { return path += "/" + v; });
                        headers = Object.assign({}, {
                            "X-ZUMO-AUTH": this.token ? this.token : undefined,
                            "X-Forwarded-Ssl": "on",
                            "Access-Control-Max-Age": 600
                        }, data.headers ? data.headers : {});
                        config = {
                            baseURL: this.baseUrl,
                            url: data.uri + path,
                            method: data.method,
                            responseType: (data.type ? data.type : "json"),
                            data: data.data ? data.data : undefined,
                            headers: headers,
                            onUploadProgress: data.onProgress ? function (ev) {
                                if (data.onProgress)
                                    data.onProgress(ev.loaded, ev.total);
                            } : undefined
                        };
                        if (this._debug)
                            console.log("config = ", config);
                        if (this._webkit)
                            this._webkit.postMessage({ type: "request", url: config.url, baseURL: config.baseURL, method: config.method });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios(config)];
                    case 2:
                        response = _a.sent();
                        rcodes = data.responseStatus ? data.responseStatus : [200, 201, 304];
                        if (_.indexOf(rcodes, response.status) < 0) {
                            if (this._webkit)
                                this._webkit.postMessage({ type: "error", status: response.status, url: config.url, baseURL: config.baseURL, method: config.method });
                            reject({ errorReason: "unexpected return code " + response.status, statusCode: response.status });
                        }
                        if (this._webkit)
                            this._webkit.postMessage({ type: "response", data: response.data, url: config.url, baseURL: config.baseURL, method: config.method });
                        resolve(response.data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (error_2.response) {
                            reject({ errorReason: error_2, statusCode: error_2.response.status, url: config.url, baseURL: config.baseURL, method: config.method });
                        }
                        else
                            reject({ errorReason: error_2 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        return toRet;
    };
    BaseClient.prototype.callLink = function (links, refName) {
        if (refName === void 0) { refName = "self"; }
        var l;
        if (links.hasOwnProperty("links"))
            l = this.canExecute(links.links, refName);
        else
            l = this.canExecute(links, refName);
        if (!l)
            return new Promise(function (resolve, reject) { return reject("link not found!"); });
        return this.execute(l);
    };
    BaseClient.prototype.execute = function (link, params, data, pathElements, responseStatus, type) {
        var _this = this;
        if (responseStatus === void 0) { responseStatus = 200; }
        if (type === void 0) { type = "json"; }
        var toRet = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var template;
            return __generator(this, function (_a) {
                template = link.uri;
                if (params !== undefined) {
                    _.forEach(params, function (v, i) {
                        var needle = "{" + i + "}";
                        if (template.indexOf(needle) === -1)
                            reject("template doesn't match passed values");
                        template = template.replace("{" + i + "}", v);
                    });
                }
                this.call({
                    uri: template,
                    method: link.method,
                    data: data,
                    pathElements: pathElements,
                    responseStatus: [responseStatus],
                    type: type,
                    onSuccess: function (val) { return resolve(val); },
                    onError: function (reason) { return reject(reason); }
                });
                return [2 /*return*/];
            });
        }); });
        return toRet;
    };
    return BaseClient;
}());
export { BaseClient };
//# sourceMappingURL=BaseClient.js.map